/**
 * Submit form on checked
 * @author Zeno Jiricek
 */

// Utilities
import debug from "debug";

const MODULE_NAME = 'core/modules/forms/submits-on-changed';
const log = debug(MODULE_NAME);


const ATTR = 'data-submits-on-changed';
const SELECTOR = `[${ATTR}]`;
const LOADINGPANEL = '.product-index__loading-panel';

export default function () {
     $(document).ready(() => {
        const $selectField = $(SELECTOR);
        const $loading = $(LOADINGPANEL);
        $selectField.show();
        log('binding submit-on-change to', $selectField);

        $selectField
            .on('change', function onChanged () {
                const $this = $(this);
                const $form = $this.parents('form');

                if ($loading.length >0) {
                    $loading.addClass('active');

                    setTimeout(function(){
                        log($this, 'changed. submitting', $form);
                        $form.submit();
                    }, 200);
                }
                else {
                    log($this, 'changed. submitting', $form);
                    $form.submit();
                }

            });
    });
}



// WEBPACK FOOTER //
// ./client/src/core/modules/forms/submits-on-changed.js